import type { Character } from '../types';

export const CHARACTERS: Character[] = [
  {
    id: 'zhaocaimao',
    name: '招财猫',
    emoji: '🐱',
    passiveName: '财运亨通',
    passiveDesc: '经过起点额外获得50金币',
    color: '#FFD700',
    style: 'stable',
  },
  {
    id: 'fox',
    name: '狐狸商人',
    emoji: '🦊',
    passiveName: '精明眼光',
    passiveDesc: '购买地产享受9折优惠',
    color: '#FF8C00',
    style: 'investment',
  },
  {
    id: 'eagle',
    name: '鹰眼投资人',
    emoji: '🦅',
    passiveName: '预知未来',
    passiveDesc: '可以看到下3张命运卡的内容',
    color: '#4169E1',
    style: 'info',
  },
  {
    id: 'turtle',
    name: '乌龟理财师',
    emoji: '🐢',
    passiveName: '稳健收益',
    passiveDesc: '租金收入+10%',
    color: '#2E8B57',
    style: 'defense',
  },
  {
    id: 'rabbit',
    name: '兔子赌徒',
    emoji: '🐰',
    passiveName: '双骰抉择',
    passiveDesc: '掷骰时可选择"双骰取高"或"双骰取低"',
    color: '#FF69B4',
    style: 'risk',
  },
  {
    id: 'dragon',
    name: '小龙律师',
    emoji: '🐲',
    passiveName: '法务豁免',
    passiveDesc: '每局可免1次罚金或入狱',
    color: '#DC143C',
    style: 'evade',
  },
  {
    id: 'owl',
    name: '猫头鹰学者',
    emoji: '🦉',
    passiveName: '谨慎决策',
    passiveDesc: '踩到地产格时可先看命运卡再决定买不买',
    color: '#8B4513',
    style: 'strategy',
  },
  {
    id: 'wolf',
    name: '野狼队长',
    emoji: '🐺',
    passiveName: '狼群战术',
    passiveDesc: '联盟时对方租金减半',
    color: '#708090',
    style: 'social',
  },
];
